module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phead13-7a0d61cacea28dc12c22c567f4077c31.jpg";